var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-text__wrap",class:{
    'show--quoted': _vm.isQuotedContentPresent,
    'hide--quoted': !_vm.isQuotedContentPresent,
  },attrs:{"dir":"auto"}},[(!_vm.isEmail)?_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.message),expression:"message"}],staticClass:"text-content",style:({
      textAlign: _vm.isRTLView ? 'right' : 'left',
    })}):_c('letter',{staticClass:"text-content",attrs:{"html":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }